<template>
    <div>
        <ion-grid  v-if="!displayErrorMessage">
            <ion-row class="search-view">
                <ion-col  size="3">
                    <ion-label>Select Branch</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            :value="branchId"
                            @ionChange="changeBranchName($event)"
                            placeholder="Select Branch"
                            interface="action-sheet"
                        >
                            <ion-select-option
                                v-for="(branchInfo, index) in this.branchList"
                            :key="index"
                            :value="branchInfo.branchId"
                            >{{ branchInfo.branch }}</ion-select-option>
                        </ion-select>
                        <select
                            @change="changeBranchName($event)"
                            class="input-select select-web"
                            v-model="branchId"
                            placeholder="Select Status"
                        >
                            <option
                            v-for="(branchInfo, index) in this.branchList"
                            :key="index"
                            :value="branchInfo.branchId"
                            >{{ branchInfo.branch }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col size="12" size-md="3" >
                    <ion-label>Select Station</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            v-model="stationId"
                            @ionChange="changeStation($event)"
                            placeholder=""
                            interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(station, index) in stationList" 
                            :key="index" 
                            :value="station.stationId"
                        >{{ station.stationName }}</ion-select-option>
                        </ion-select>

                        <select
                            v-model="stationId"
                            @change="changeStation($event)"
                            class="input-select select-web"
                            placeholder=""
                        >
                        <option
                            v-for="(station, index) in stationList" 
                            :key="index" 
                            :value="station.stationId"
                        >{{ station.stationName }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col size="3" class="btn-list">
                    <ion-button class="btn-search" @click="getReportList">Get Report List</ion-button>
                    <ion-button class="btn-clear " @click="clearFields">
                        <ion-icon :icon="refresh"></ion-icon>
                    </ion-button>
                </ion-col>
                
            </ion-row>
            <ion-row v-if="displayReportList" class="report-list">
                <ion-col v-for="report in this.reportList" :key="report" size="4" @click="reportDetails(report)">
                    <ion-row class="container-div">
                        <ion-col size="10">
                            <p class="usage-txt">{{report.reportName}}</p>
                        </ion-col>
                        <ion-col size="2">
                            <ion-icon :icon="arrowForwardOutline" class="custom-icon"></ion-icon>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row v-if="displayNoRecordData" class="no-records">
                <ion-col class="ion-text-center txt-color">No report list for selected branch</ion-col>
            </ion-row>
            <!-- <UsageReport :branchName="branchList"/> -->
        </ion-grid>
        <div v-if="displayErrorMessage">
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <p class="noAssociatedStations"  style="text-align: center;">{{ errorMessage }}</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
            </div>
    </div>
    
</template>

<script>
import { IonButton, IonCol, IonGrid, IonIcon, IonLabel, IonRow, IonSelect, IonSelectOption} from "@ionic/vue";
import { defineComponent } from "vue";
import { arrowForwardOutline, receiptOutline, refresh } from 'ionicons/icons';
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";
import UsageReport from "./usageReport.vue";

export default defineComponent({
    name: 'cpoReport',
    components:{
        IonIcon, IonGrid, IonRow, IonCol, IonIcon, IonButton, IonSelect, IonSelectOption, IonLabel
    },
    data(){
        return{
            refresh,
            branchList: [],
            branchId: "",
            stationId: "",
            getList: "",
            receiptOutline,
            arrowForwardOutline,
            reportList : [],            
            displayReportList: false,
            reportRoutes: [
                { code: "UsageReport", path: "usageReport" },
                { code: "TransactionReport", path: "transactionReport" },
                { code: "ChargerStatusReport", path: "chargerstatusreport" }
            ],
            storedBranchId: "",
            displayNoRecordData: false,
            displayErrorMessage: false,
            errorMessage: "",
            stationList: [],
        }
    },
    async mounted() {
        await this.getBranchListForReport();
        // this.stationList = await new CorporateService().getStationList(this.branchId);
    },
    methods: {
        async changeBranchName(event) {
            this.branchId = event.target.value;
            localStorage.setItem("reportListBranchId", JSON.stringify(this.branchId))
            this.stationList = (await new CorporateService().getStationList(this.branchId))
            .filter(station => station.stationId !== 0);
            
            if(this.stationList) {
                this.stationId = this.stationList[0].stationId
                localStorage.setItem("reportListStationId", JSON.stringify(this.stationId))
            }
            
            this.displayReportList = false;
            this.displayNoRecordData = false;
        },
        async changeStation(event) {
            this.stationId = event.target.value;
        },
        async clearFields() {
            localStorage.removeItem("reportListBranchId")
            localStorage.removeItem("reportListStationId")
            // window.localStorage.removeItem("reportListBranchId");
            this.branchId = this.branchList[0].branchId;
            this.stationList = (await new CorporateService().getStationList(this.branchId))
            .filter(station => station.stationId !== 0);

            if (this.stationList.length > 0) {
                this.stationId = this.stationList[0].stationId;
            }
            this.getReportList();
        },
        async getBranchListForReport() {
            this.branchList = [];
            this.loaderTab = true;
            try {
                let branchList =  await new CorporateService().getBranchListForReport();
                if(branchList.data.length > 0) {
                    this.branchList = branchList.data;
                    this.storedBranchId = JSON.parse(localStorage.getItem("reportListBranchId"))
                    if( this.storedBranchId ) {
                        this.branchId = this.storedBranchId
                    } else {
                        this.branchId = this.branchList[0].branchId;
                    }
                    this.stationList = (await new CorporateService().getStationList(this.branchId))
                    .filter(station => station.stationId !== 0);
                    if(this.stationList) {
                        this.stationId = this.stationList[0].stationId
                    }
                    this.getReportList();
                    this.loaderTab = false;
                } else {
                    this.loaderTab = false;
                    this.displayErrorMessage = true;
                    this.errorMessage = branchList.errors.description;
                }
                
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        
        },
        async getReportList() {
            // console.log("display")
            try {
                // this.displayReportList = false;
                this.loaderTab = true;
                this.reportList = await new CorporateService().getReportList(this.branchId, this.stationId);
                if( this.reportList.length > 0) {
                    this.displayReportList = true;
                    this.displayNoRecordData = false;
                }else{
                    this.displayReportList = false;
                    this.displayNoRecordData = true;
                }
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        // reportDetails(report) {
        //     let branch = JSON.stringify(report)
        //     localStorage.setItem("branchInfoFromReportList", branch)
        //     this.$router.push(report.reportPath);
        // },
        reportDetails(report) {
            let branch = JSON.stringify(report)
            localStorage.setItem("branchInfoFromReportList", branch)
            if(report.reportCode == "UR" ) {
                this.$router.push("usageReport");   
            } else if(report.reportCode == "TR" ) {
                this.$router.push("transactionReport");   
            } else {
                this.$router.push("chargerstatusreport");
            }
            // this.$router.push(report.reportPath);
        },
        
    },
})
</script>

<style scoped>
.btn-list{
    margin: 25px 0 0 10px;
}
.report-list{
    margin: 80px 0 0 0;
}
.card-container{
    margin-top: 30px;
}
.custom-icon{
    cursor: pointer;
    color: #ffff;
    font-size: 14px;
    font-weight: bold;
    padding: 8px;
    margin-top: 20px;
    background-color: #099c14;
    border-radius: 50%;
    /* border: 2px solid black; */
}
ion-card-title{
    font-weight: bold;
}
ion-card-subtitle{
    color: #cc6b16;
}
.view-details{
    color: #099c14;
    text-align: center;
}
.card-subtitle{
    color: #1520ed;
    font-size: 11px;
}
.chart-container {
  width: 50%;
  height: 120px;
  /* padding: 10px; */
}
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
.no-records{
    margin-top: 110px;
    /* background-color: #6777a2; */
}
.txt-color{
    font-size: 16px;
}
</style>
